module.exports = __webpack_public_path__ + "img/neutral.ec1d06a1.svg";